"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionsClient = void 0;
var clients_1 = require("src/clients");
var models_1 = require("src/models");
var constants_1 = require("../constants");
/**
 * SDK for interacting with collections in AppDB.
 *
 * ### Example Usage
 *
 * ```js
 * import { AppDBClient } from '@domoinc/toolkit';
 *
 * const collections = await (new AppDBClient.CollectionsClient()).getCollections();
 * // do something with the collections
 * console.table(collections);
 * ```
 */
var CollectionsClient = /** @class */ (function () {
    function CollectionsClient(reCaptchaToken) {
        this.transportClient = clients_1.TransportClient;
        this.reCaptchaHeader =
            reCaptchaToken === undefined
                ? {}
                : {
                    'X-DOMO-Ryuu-Recaptcha': reCaptchaToken,
                };
    }
    /**
     * A helper method for retrieving a full list of collections.
     */
    CollectionsClient.prototype.getCollections = function () {
        return this.transportClient.get(constants_1.LIST_COLLECTIONS, undefined, __assign({ accept: models_1.DataFormatTypes.json }, this.reCaptchaHeader));
    };
    /**
     * A helper method for creating a new collection.
     *
     * @param newCollection Properties for new collection
     *
     * ### Example Usage
     *
     * ```js
     * collectionsClient.createCollection({
     *   name: 'newCollection',
     *   schema: [
     *     {
     *       name: 'name',
     *       type: 'STRING'
     *     },
     *     {
     *       name: 'age',
     *       type: 'LONG'
     *     },
     *   ],
     *   syncEnabled: true,
     * });
     * ```
     */
    CollectionsClient.prototype.createCollection = function (newCollection) {
        var _a;
        var newCollectionStringParser = __assign(__assign({}, newCollection), { defaultPermissions: !!newCollection.defaultPermissions &&
                newCollection.defaultPermissions.length > 0
                ? (_a = newCollection.defaultPermissions) === null || _a === void 0 ? void 0 : _a.join(',')
                : undefined });
        return this.transportClient.post(constants_1.CREATE_COLLECTION, JSON.stringify(newCollectionStringParser), __assign({ accept: models_1.DataFormatTypes.json, 'content-type': models_1.DataFormatTypes.json }, this.reCaptchaHeader));
    };
    /**
     * A helper method for updating a collection.
     *
     * @param collectionId ID of target collection to update
     * @param updatedConfig Partial object representing the new values of the collection
     *
     * ### Example Usage
     *
     * ```js
     * collectionsClient.updateCollection(
     *   '753e53a0-f054-11e9-81b4-2a2ae2dbcce4',
     *   {
     *    schema: [
     *      {
     *        name: 'name',
     *        type: 'STRING'
     *      },
     *      {
     *        name: 'created',
     *        type: 'DATETIME'
     *      },
     *    ],
     *   }
     * );
     * ```
     */
    CollectionsClient.prototype.updateCollection = function (collectionId, updatedConfig) {
        var _a;
        var newCollectionStringParser = __assign(__assign({}, updatedConfig), { defaultPermissions: !!updatedConfig.defaultPermissions &&
                updatedConfig.defaultPermissions.length > 0
                ? (_a = updatedConfig.defaultPermissions) === null || _a === void 0 ? void 0 : _a.join(',')
                : undefined });
        return this.transportClient.put((0, constants_1.EDIT_COLLECTION)(collectionId), JSON.stringify(newCollectionStringParser), __assign({ accept: models_1.DataFormatTypes.json, 'content-type': models_1.DataFormatTypes.json }, this.reCaptchaHeader));
    };
    /**
     * A helper method for deleting a collection.
     *
     * @param collectionId ID of target collection to delete
     *
     * ### Example Usage
     *
     * ```js
     * collectionsClient.deleteCollection('753e53a0-f054-11e9-81b4-2a2ae2dbcce4');
     * ```
     */
    CollectionsClient.prototype.deleteCollection = function (collectionId) {
        return this.transportClient.delete((0, constants_1.DELETE_COLLECTION)(collectionId), undefined, __assign({ accept: models_1.DataFormatTypes.json }, this.reCaptchaHeader));
    };
    /**
     * A helper method for forcing the collections to be sync'd with their respective
     * datasets in Domo.
     */
    CollectionsClient.prototype.syncWithDomo = function () {
        return this.transportClient.post(constants_1.EXPORT_COLLECTIONS, undefined, __assign({ accept: models_1.DataFormatTypes.json, 'content-type': models_1.DataFormatTypes.json }, this.reCaptchaHeader));
    };
    return CollectionsClient;
}());
exports.CollectionsClient = CollectionsClient;
